import React, { useState } from 'react';
import Icon from '../../../../components/AppIcon';

const QuestionAnalysis = ({ questions }) => {
  const [expandedQuestion, setExpandedQuestion] = useState(null);

  const toggleQuestion = (id) => {
    setExpandedQuestion(prev => (prev === id ? null : id));
  };

  return (
    <div className="bg-card border border-border rounded-lg p-6 shadow-elevation-1">

      <div className="flex items-center gap-3 mb-6">
        <div className="w-10 h-10 bg-secondary/10 rounded-lg flex items-center justify-center">
          <Icon name="FileText" size={20} />
        </div>
        <h3 className="text-lg font-semibold">Question Analysis</h3>
      </div>

      <div className="space-y-3">
        {questions?.map((q, index) => {

          const id = q?._id || index;

          return (
            <div key={id} className="border rounded-lg overflow-hidden">

              {/* HEADER */}
              <button
                onClick={() => toggleQuestion(id)}
                className="w-full px-4 py-3 flex justify-between bg-gray-50"
              >
                <div className="flex items-center gap-3">
                  <span>Q{index + 1}</span>

                  <Icon
                    name={q?.isCorrect ? "CheckCircle2" : "XCircle"}
                    color={q?.isCorrect ? "green" : "red"}
                  />

                  <span className="truncate max-w-[500px] text-left">
                    {q?.question}
                  </span>
                </div>

                <Icon name="ChevronDown" />
              </button>

              {/* BODY */}
              {expandedQuestion === id && (
                <div className="p-4 space-y-4">

                  {/* QUESTION */}
                  <div>
                    <p className="text-gray-500 text-sm">Question:</p>
                    <p>{q?.question}</p>
                  </div>

                  {/* OPTIONS */}
                  {q?.options?.length > 0 && (
                    <div>
                      <p className="text-gray-500 text-sm mb-2">Options:</p>
                      <div className="space-y-2">
                        {q.options.map((opt, i) => (
                          <div
                            key={i}
                            className={`p-2 rounded border ${
                              opt === q.correctAnswer
                                ? "bg-green-100"
                                : opt === q.userAnswer
                                ? "bg-red-100"
                                : ""
                            }`}
                          >
                            {opt}
                          </div>
                        ))}
                      </div>
                    </div>
                  )}

                  {/* USER ANSWER */}
                  <div>
                    <p className="text-gray-500 text-sm">Your Answer:</p>
                    <p className="text-red-600">{q.userAnswer || "Not Answered"}</p>
                  </div>

                  {/* CORRECT ANSWER */}
                  {!q.isCorrect && (
                    <div>
                      <p className="text-gray-500 text-sm">Correct Answer:</p>
                      <p className="text-green-600">{q.correctAnswer}</p>
                    </div>
                  )}

                  {/* CODING OUTPUT */}
                  {q.type === "coding" && (
                    <div>
                      <p className="text-gray-500 text-sm">Your Code:</p>
                      <pre className="bg-black text-green-400 p-3 rounded text-sm overflow-auto">
                        {q.code}
                      </pre>

                      <p className="text-gray-500 text-sm mt-2">Test Results:</p>
                      {q.testResults?.map((t, i) => (
                        <div key={i} className="text-sm">
                          {t.passed ? "✅ Passed" : "❌ Failed"} → Output: {t.output}
                        </div>
                      ))}
                    </div>
                  )}

                </div>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default QuestionAnalysis;